import { Grid, Container } from '@material-ui/core'
import React from 'react'
import { isMobile } from 'react-device-detect'
import FlexView from 'react-flexview/lib'
import { BuyingInsuranceContextStore } from '../../context/BuyingInsuranceContext'
import { SessionContextStore } from '../../context/SessionContext'
import DataLayerService from '../../services/DataLayerService'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import { BackButton } from '../Core/Buttons/BackButton'
import { NewCoveragePlanCard } from './Coverages/NewCoveragePlanCard'
import Skeleton from '@material-ui/lab/Skeleton'
import { reportGTM } from '../Core/Utilities/GTagManger'
import { awaitWithLoading } from '../../services/utils'

export const CoveragePicker = () => {
  const sessionContext = React.useContext(SessionContextStore)
  const offersContext = React.useContext(BuyingInsuranceContextStore)
  const [showLoading, setShowLoading] = React.useState(true)

  const onPlanPicked = plan => {
    offersContext.choosePlan(plan)
    reportGTM('', '', {
      event: 'Coverage-plan-selected',
      plan: plan.name,
      price: plan.price,
      perMileCharge: plan.perMileCharge,
      fixedPrice: plan.fixedPrice,
    })
    EventEmitterService.dispatch(EventKey.FLOW_COVERAGE_PLAN_PICKED)
  }

  React.useEffect(() => {
    let plans = offersContext.plans.items
    if (plans && plans.length > 0 && plans[plans.length - 1] && plans[plans.length - 1].price > 1) {
      setShowLoading(false)
    }
  }, [offersContext.plans])

  React.useEffect(() => {
    if ((offersContext.plans.items.length === 0 && offersContext.plans.status === 'idle') || offersContext.shouldLoadPlans) {
      awaitWithLoading(offersContext.loadPlans())
      offersContext.loadPlansAfterMvrChange(false)
    }
  }, [])

  return (
    <>
      {!isMobile && <div style={{ height: '32px' }} />}
      <Grid container spacing={1}>
        {offersContext.plans.items.map((plan, index) => (
          <Grid key={index} item xs={12} md={4}>
            <FlexView className="full-width space-between">
              {showLoading ? (
                <Container maxWidth="xs">
                  <Skeleton variant="text" width={'100%'} height={400} />
                </Container>
              ) : (
                <NewCoveragePlanCard onClick={() => onPlanPicked(plan)} isHighlighted={false} plan={plan} />
              )}
            </FlexView>
          </Grid>
        ))}
      </Grid>
      <br />
      <BackButton />
    </>
  )
}
